import './RangeLegend.css';
import { createRuntimeFn as _7a468 } from '@vanilla-extract/recipes/createRuntimeFn';
export var legendContainer = _7a468({defaultClassName:'_1e2poyg0-2-0-1',variantClassNames:{isVertical:{true:'_1e2poyg1-2-0-1',false:'_1e2poyg2-2-0-1'}},defaultVariants:{},compoundVariants:[]});